import { render, staticRenderFns } from "./SocialCommentsandLikes.vue?vue&type=template&id=54223a3f&"
import script from "./SocialCommentsandLikes.vue?vue&type=script&lang=js&"
export * from "./SocialCommentsandLikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports